var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b7b7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5,13.06c-2.13,0-3.1-1-3.08-3.13a8.13,8.13,0,0,1,8.2-8c2,0,2.91,1,2.92,3A8.1,8.1,0,0,1,5,13.06Zm.14-.93a7.17,7.17,0,0,0,7-7.1c0-1.59-.56-2.12-2.14-2.16a7.18,7.18,0,0,0-7.12,7C2.86,11.58,3.41,12.13,5.16,12.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.66,7.51l-.82-.75-.59.77L9,8.37,8.38,9,7.5,8.21l-.69.64.79.92L7,10.34,6.11,9.6l-1.05,1L4.4,10l1-1.06L4.62,8l.65-.56.89.78.51-.84L6,6.62,6.62,6l.88.78.69-.65L7.4,5.22l.66-.57.83.75,1-1L10.6,5l-1,1,.78.91Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSports);
export default __webpack_public_path__ + "static/media/sports.c8a996d439aa7b9a173616ca2eb2fb8d.svg";
export { ForwardRef as ReactComponent };